import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Key points row. Updates when the selected product variant changes.
 *
 * @extends {Component}
 */
class KeyPoints extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (closestSection) {
      closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (closestSection) {
      closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    }
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const next = html.querySelector(`key-points[data-block-id="${this.dataset.blockId}"]`);
        if (!next) return;

        this.replaceWith(next);
      })
      .catch(() => {
        // Ignore aborted variant fetches
      });
  };
}

if (!customElements.get('key-points')) {
  customElements.define('key-points', KeyPoints);
}
